<template>
  <transition name="fade">
    <div v-if="visible" class="global-notify" :class="info.msgType">
      <div class="notify-title">
        {{ titleMap[info.msgType] || '系统通知' }}
      </div>

      <img v-if="showAvatar" :src="processedAvatar" class="avatar" />
      <span class="nickname" v-if="showNickname">{{ showNickname }}</span>

      <!-- 支持手机号展示 -->
      <span class="mobile" v-if="showMobile">手机号：{{ showMobile }}</span>

      <!-- 扩展内容展示 -->
      <span class="content" v-if="showContent">{{ showContent }}</span>

      <!-- 支持双对象（如customer、player）展示 -->
      <template v-if="info.customer || info.player">
        <div v-if="info.customer" class="role-block">
          <span class="role-label">客户：</span>
          <img v-if="info.customer.avatar" :src="processAvatarUrl(info.customer.avatar)" class="avatar small" />
          <span class="nickname">{{ info.customer.nickname }}</span>
        </div>
        <div v-if="info.player" class="role-block">
          <span class="role-label">陪玩：</span>
          <img v-if="info.player.avatar" :src="processAvatarUrl(info.player.avatar)" class="avatar small" />
          <span class="nickname">{{ info.player.nickname }}</span>
        </div>
      </template>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalNotify',
  props: {
    info: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      titleMap: {
        '注册用户': '新用户注册',
        '绑定手机号': '绑定手机号',
        '用户下单': '用户下单通知',
        '陪玩_准备下单': '准备下单提醒',
        '城市合作': '城市合作来啦', // ← 新增
      }
    }
  },
  computed: {
    // 兼容多种结构，优先级：customer > player > 根字段
    showAvatar() {
      if (this.info.customer && this.info.customer.avatar) return this.info.customer.avatar;
      if (this.info.player && this.info.player.avatar) return this.info.player.avatar;
      return this.info.avatar || '';
    },
    processedAvatar() {
      return this.processAvatarUrl(this.showAvatar);
    },
    showNickname() {
      if (this.info.customer && this.info.customer.nickname) return this.info.customer.nickname;
      if (this.info.player && this.info.player.nickname) return this.info.player.nickname;
      return this.info.nickname || '';
    },
    showMobile() {
      if (this.info.mobile) return this.info.mobile;
      if (this.info.customer && this.info.customer.mobile) return this.info.customer.mobile;
      if (this.info.player && this.info.player.mobile) return this.info.player.mobile;
      return '';
    },
    showContent() {
      return this.info.content || '';
    }
  },
  methods: {
    processAvatarUrl(url) {
      if (!url) return ''
      // www.* → api.*
      const processedUrl = url.replace(/^https?:\/\/www\./, m => m.replace('www', 'api'))
      return processedUrl
    }
  }
}
</script>

<style scoped>
.global-notify {
  position: fixed;
  z-index: 99999;
  top: 36px;
  right: 32px;
  left: auto;
  background: rgba(255,255,255,0.98);
  border-radius: 16px;
  padding: 24px 36px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 20px rgba(100,100,130,0.12);
  min-width: 180px;
  max-width: 90vw;
  font-size: 17px;
  border: 1px solid #f1f3fa;
}
.notify-title {
  font-size: 16px;
  color: #68b900;
  font-weight: 600;
  margin-bottom: 14px;
  text-align: center;
}

.global-notify.预警 .notify-title { color: #f56c6c; }
.global-notify.投诉 .notify-title { color: #e6a23c; }
.global-notify.注册用户 .notify-title { color: #409EFF; }
.global-notify.陪玩_准备下单 .notify-title { color: #10b981; } /* teal 风格 */
.global-notify.城市合作 .notify-title { color: #16a34a; }     /* 城市合作：青绿色 */

.avatar {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin-bottom: 12px;
  object-fit: cover;
  border: 1.5px solid #f1f1f1;
  background: #f6f6f6;
}
.avatar.small {
  width: 32px;
  height: 32px;
  margin-bottom: 0;
  margin-right: 8px;
  vertical-align: middle;
}
.nickname {
  font-weight: 500;
  font-size: 19px;
  color: #2c2c2c;
  letter-spacing: 1px;
  text-align: center;
}
.mobile {
  font-size: 14px;
  color: #666;
  margin-top: 2px;
}
.content {
  margin-top: 8px;
  font-size: 15px;
  color: #888;
  text-align: center;
}
.role-block {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.role-label {
  font-size: 13px;
  color: #999;
  margin-right: 6px;
}

.fade-enter-active, .fade-leave-active { transition: all .3s; }
.fade-enter, .fade-leave-to { opacity: 0; transform: translateY(-22px) scale(0.97);}
</style>
